import * as Sentry from "@sentry/browser"

type Options = {
  tags?: Record<string, string>
  level?: Sentry.Severity
  extra?: Record<string, unknown>
}

export default function reportError(err: Error, options?: Options): void {
  Sentry.withScope((scope) => {
    if (options?.tags) {
      scope.setTags(options.tags)
    }
    if (options?.level) {
      scope.setLevel(options.level)
    }
    if (options?.extra) {
      scope.setContext("extra", options.extra)
    }

    Sentry.captureException(err)
  })
}
